import { EanURL } from '../common/eanUtils';
import { NavigateFunction } from 'react-router-dom';
import { NotificationFactoryInterface } from './notificationFactoryInterface';
import { NotificationResponse } from '../models/NotificationResponse';
import { OVERVIEW_TABS } from '../enum/OverviewTabsEnums';
import { routes } from '../routes';

export class NotificationSmartMeterFirstDataFactory implements NotificationFactoryInterface {
  constructor(
    private notification: NotificationResponse,
    private navigate: NavigateFunction
  ) {}

  canRedirect(): boolean {
    return this.notification.data?.sdpId;
  }

  redirect(): void {
    if (!this.canRedirect()) {
      return;
    }
    this.navigate(
      `${routes.withArgs(
        `${routes.OVERVIEW.path}${routes.OVERVIEW.children.OVERVIEW_DETAIL.path}`,
        {
          ':id': EanURL.encrypt(this.notification.data?.sdpId!) as string,
          ':tabId': OVERVIEW_TABS.CONSUMPTION,
        }
      )}${window.location.search}`
    );
  }
}
